import { Css } from "@homebound/beam";
import { startOfDecade, startOfMonth, startOfQuarter, startOfToday, startOfYear } from "date-fns";
import { DateOnly } from "src/utils/dates";

export enum BudgetMetricsViewType {
  MTD = "Month-to-date",
  QTD = "Quarter-to-date",
  YTD = "Year-to-date",
  ALL_TIME = "All time",
}

type ViewTypeFilterProps = {
  viewType: BudgetMetricsViewType;
  setViewType: React.Dispatch<React.SetStateAction<BudgetMetricsViewType>>;
};

export function ViewTypeFilter({ viewType, setViewType }: ViewTypeFilterProps) {
  return (
    <div css={Css.br4.ba.bcGray300.bgWhite.df.mla.$}>
      <button
        css={Css.sm.br.wPx(60).bcGray300.if(viewType === BudgetMetricsViewType.MTD).bgGray200.$}
        onClick={() => setViewType(BudgetMetricsViewType.MTD)}
      >
        MTD
      </button>
      <button
        css={Css.sm.br.bcGray300.wPx(60).if(viewType === BudgetMetricsViewType.QTD).bgGray200.$}
        onClick={() => setViewType(BudgetMetricsViewType.QTD)}
      >
        QTD
      </button>
      <button
        css={Css.sm.br.bcGray300.wPx(60).if(viewType === BudgetMetricsViewType.YTD).bgGray200.$}
        onClick={() => setViewType(BudgetMetricsViewType.YTD)}
      >
        YTD
      </button>
      <button
        css={Css.sm.p1.wPx(86).if(viewType === BudgetMetricsViewType.ALL_TIME).bgGray200.$}
        onClick={() => setViewType(BudgetMetricsViewType.ALL_TIME)}
      >
        All Time
      </button>
    </div>
  );
}

export function getFromDate(viewType: BudgetMetricsViewType, snapshot?: boolean): DateOnly | undefined {
  const today = new DateOnly(startOfToday());
  switch (viewType) {
    case BudgetMetricsViewType.MTD:
      return new DateOnly(startOfMonth(today));
    case BudgetMetricsViewType.QTD:
      return new DateOnly(startOfQuarter(today));
    case BudgetMetricsViewType.YTD:
      return new DateOnly(startOfYear(today));
    default:
      // TODO: handle "ALL_TIME" case for snapshots, we'd need to return the first usable snapshot for the project.
      return snapshot ? new DateOnly(startOfDecade(today)) : undefined;
  }
}
